export default {
  methods: {
    formatBytes (bytes, size = 2, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1000
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      return parseFloat((bytes / Math.pow(k, size)).toFixed(dm)) + ' ' + sizes[size]
    }
  }
}
